<template>
  <DebugConsole v-if="debugMode" />
  <router-view v-if="auth || noPassword" />
</template>

<script>
import { ref, provide } from "vue";
import DebugConsole from "./common/debug-console.vue";

export default {
  name: "main-app",
  setup() {
    const idle = ref(true);
    const filled = false;
    const profileFilled = ref(filled);
    const auth = true;
    function updateAuth() {
      auth.value = true;
      window.sessionStorage.auth = true;
    }
    function updateIdle() {
      idle.value = !idle.value;
    }
    function updateProfileFilled(value) {
      profileFilled.value = value;
    }
    provide("profileFilled", { profileFilled, updateProfileFilled });
    provide("idle", { idle, updateIdle });
    provide("auth", { auth, updateAuth });

    return {
      auth,
      idle,
      currentUser: undefined,
    };
  },
  data() {
    let debugMode = false;
    let appVersion = "1.0.3";
    let appTitle = `HKUST x PanopticAI ${appVersion}`;

    return {
      vitalSignObject: undefined,
      healthObject: undefined,
      host: location.host,
      appVersion: appVersion,
      appTitle: appTitle,
      debugMode: debugMode,
      debugMessage: "[ Your debug message ]",
    };
  },
  mounted() {
    if (this.debugMode) {
      console.log(`%c< ${this.appTitle} > DEBUG MODE`, "color: red");
    } else {
      console.log(`< ${this.appTitle} >`);
    }
  },
  computed: {
    noPassword() {
      return (
        this.host.match(/^localhost:[\d]{1,4}/) ||
        location.href.match(/^.*\/#\/report.*/)
      );
    },
  },
  components: {
    DebugConsole,
  },
};
</script>
